export type SupportSettingToggle = {
  enabled: boolean;
};

/**
 * Runtime feature kill switch in svc-support settings.
 * enabled: true → on for everyone. enabled: false → only bypassRequestors; empty list → off for everyone.
 */
export type SupportFeatureSetting = SupportSettingToggle & {
  bypassRequestors: string[];
};

export type BypassableFeatureKey =
  | 'SIERRA_EMAIL_AI'
  | 'SALES_INTENT_ROUTING'
  | 'FLIGHT_INTENT_ROUTING'
  | 'SUPPORT_INTENT_CLARIFICATION'
  | 'CUSTOMER_AUTO_SOLVE'
  | 'CUSTOMER_PARTNERSHIP_DEFLECT'
  | 'CUSTOMER_REPLY_MERGE';

export const BYPASSABLE_FEATURE_KEYS = [
  'SIERRA_EMAIL_AI',
  'SALES_INTENT_ROUTING',
  'FLIGHT_INTENT_ROUTING',
  'SUPPORT_INTENT_CLARIFICATION',
  'CUSTOMER_AUTO_SOLVE',
  'CUSTOMER_PARTNERSHIP_DEFLECT',
  'CUSTOMER_REPLY_MERGE',
] as const satisfies readonly BypassableFeatureKey[];

export const DEFAULT_BYPASSABLE_FEATURE_SETTING: SupportFeatureSetting = {
  enabled: false,
  bypassRequestors: [],
};

export interface SettingsFormData {
  GENESYS: SupportSettingToggle;
  CHRISTMAS: SupportSettingToggle;
  SIERRA_EMAIL_AI: SupportFeatureSetting;
  SALES_INTENT_ROUTING: SupportFeatureSetting;
  FLIGHT_INTENT_ROUTING: SupportFeatureSetting;
  SUPPORT_INTENT_CLARIFICATION: SupportFeatureSetting;
  CUSTOMER_AUTO_SOLVE: SupportFeatureSetting;
  CUSTOMER_PARTNERSHIP_DEFLECT: SupportFeatureSetting;
  CUSTOMER_REPLY_MERGE: SupportFeatureSetting;
}

export const DEFAULT_SETTINGS: SettingsFormData = {
  GENESYS: {
    enabled: false,
  },
  CHRISTMAS: {
    enabled: false,
  },
  SIERRA_EMAIL_AI: { ...DEFAULT_BYPASSABLE_FEATURE_SETTING, enabled: true },
  // Keep in sync with svc-zendesk supportSettings fail-closed defaults.
  SALES_INTENT_ROUTING: DEFAULT_BYPASSABLE_FEATURE_SETTING,
  FLIGHT_INTENT_ROUTING: DEFAULT_BYPASSABLE_FEATURE_SETTING,
  SUPPORT_INTENT_CLARIFICATION: DEFAULT_BYPASSABLE_FEATURE_SETTING,
  CUSTOMER_AUTO_SOLVE: DEFAULT_BYPASSABLE_FEATURE_SETTING,
  CUSTOMER_PARTNERSHIP_DEFLECT: DEFAULT_BYPASSABLE_FEATURE_SETTING,
  CUSTOMER_REPLY_MERGE: DEFAULT_BYPASSABLE_FEATURE_SETTING,
};
